module.exports = __webpack_public_path__ + "static/media/events_02.5125fd39.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/events/JPEG/events_02.jpg
// module id = 5920
// module chunks = 0